import { render, staticRenderFns } from "./ClientsByModuleStatistics.vue?vue&type=template&id=061bd738&scoped=true&"
import script from "./ClientsByModuleStatistics.vue?vue&type=script&lang=ts&"
export * from "./ClientsByModuleStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsByModuleStatistics.vue?vue&type=style&index=0&id=061bd738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061bd738",
  null
  
)

export default component.exports